import { Error } from '../../ErrorHandling';
import { Link, Resource } from '../../Resource/Types';
import { StringOption } from '../../components/Options/Types';

export interface ParticipantsOptions {
  loginActivities: StringOption[];
  userGroups: StringOption[];
  programs: StringOption[];
  learningCollections: StringOption[];
  licenses: StringOption[];
  licenseTypes: StringOption[];
  licenseStatuses: StringOption[];
  licenseStartDates: StringOption[];
}

export type ParticipantsOptionsResource = Resource<ParticipantsOptions>;

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
  links: ReadonlyArray<Link>;
}

export interface Ready {
  kind: 'ready';
  resource: ParticipantsOptionsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (links: ReadonlyArray<Link>): Loading => ({
  kind: 'loading',
  links,
});

export const ready = (resource: ParticipantsOptionsResource): Ready => ({
  kind: 'ready',
  resource,
});

export type State = Waiting | Loading | Ready | Error;
